import { render, staticRenderFns } from "./PageSignUp.vue?vue&type=template&id=9ab01b76&"
import script from "./PageSignUp.vue?vue&type=script&lang=ts&"
export * from "./PageSignUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports